import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const packageFeaturesReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.PACKAGE_FEATURE_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case actions.PACKAGE_FEATURE_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case actions.PACKAGE_FEATURE_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.PACKAGE_FEATURES_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.PACKAGE_FEATURES_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.PACKAGE_FEATURES_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.PACKAGE_FEATURE_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.PACKAGE_FEATURE_UPDATE_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.PACKAGE_FEATURE_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const packageFeatureReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.PACKAGE_FEATURE_READ_BEGIN:
      return {
        ...initialStateSingle,
        loading: true,
      };

    case actions.PACKAGE_FEATURE_READ_SUCCESS:
      return {
        ...initialStateSingle,
        data,
        error: false,
        loading: false,
      };

    case actions.PACKAGE_FEATURE_READ_ERR:
      return {
        ...initialStateSingle,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { packageFeaturesReducer, packageFeatureReducer };
